import { HighlightOffOutlined } from "@mui/icons-material";
import {
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import * as React from "react";
import { useWishlist } from "../../../../hooks/useWishlist";
import { useXoraiaValue } from "../../../../hooks/useXoraia";
import { IArticleData } from "../../../../utils/interfaces/common/XArticle.interfaces";

const WishList: React.FC = () => {
  const { imageComponent, env } = useXoraiaValue();

  const { wishlist, setWishlist } = useWishlist();

  if (wishlist.carts.length === 0) {
    return (
      <Stack p={3} alignItems="center" justifyContent="center">
        <Typography>Votre Liste de Favoris est vide</Typography>
      </Stack>
    );
  }

  const removeArticle = async (article: IArticleData) => {
    try {
      setWishlist((old) => {
        const carts = old.carts.filter((e) => e.id !== article.id);

        return { ...old, carts };
      });
    } catch (error) {
      console.error("REMOVE ARTICLE FROM CART =>", error);
    }
  };

  return (
    <React.Fragment>
      <List
        disablePadding
        sx={{
          flex: 1,
          fontFamily: "inherit",
          "& .MuiListItem-container:not(:last-of-type)": {
            borderBottom: 1,
            borderBottomColor: "rgba(0, 0, 0, 0.12)",
          },
        }}
      >
        {wishlist.carts.map(({ id, images, name, price }) => {
          return (
            <ListItem key={id} alignItems="flex-start">
              {imageComponent && (
                <ListItemAvatar
                  sx={{
                    width: "60px",
                    height: "70px",
                    position: "relative",
                  }}
                >
                  {imageComponent(
                    {
                      src: images[0],
                      alt: name,
                      width: "60px",
                      height: "70px",
                    },
                    env ?? "prod",
                    {},
                    "article id"
                  )}
                </ListItemAvatar>
              )}
              <ListItemText
                sx={{ mx: 1 }}
                primary={name}
                primaryTypographyProps={{
                  sx: {
                    fontFamily: "inherit",
                    mb: 2,
                    lineHeight: "1em",
                    fontWeight: 600,
                  },
                }}
                secondaryTypographyProps={{ component: "div" }}
                secondary={
                  <>
                    <Typography
                      sx={{
                        lineHeight: "1em",
                        fontFamily: "inherit",
                        mb: 1.5,
                        "& span": { color: "#999999", mr: 1 },
                      }}
                    >
                      <b>{price} F CFA</b>
                    </Typography>
                  </>
                }
              />
              <ListItemSecondaryAction>
                <IconButton
                  size="small"
                  color="error"
                  onClick={async () =>
                    await removeArticle({ images, id } as any)
                  }
                >
                  <HighlightOffOutlined />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          );
        })}
      </List>
    </React.Fragment>
  );
};

export default WishList;
